// extracted by mini-css-extract-plugin
module.exports = {"input":"FormText_input__3zlnY"};